// extracted by mini-css-extract-plugin
export default {"link":"D7jF2"};